import { render, staticRenderFns } from "./allform.vue?vue&type=template&id=5eb5220e&scoped=true&"
import script from "./allform.vue?vue&type=script&lang=js&"
export * from "./allform.vue?vue&type=script&lang=js&"
import style0 from "./allform.vue?vue&type=style&index=0&id=5eb5220e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb5220e",
  null
  
)

export default component.exports